import { forwardRef, HTMLProps } from 'react'
import clsx from 'classnames'
import style from './timeline-thumbs.module.scss'

interface TimelineThumbsProps extends HTMLProps<HTMLUListElement> {
  // TODO: Добавить типизацию для items
  items: any[]
  selectedIndex: number
  onThumbClick: (index: number) => void
}

export const TimelineThumbs = forwardRef<HTMLUListElement, TimelineThumbsProps>((props, ref) => {
  const { className, items, selectedIndex, onThumbClick } = props

  return (
    <nav className={clsx(style.container, className)} ref={ref}>
      {items?.map((item, index) => (
        <button
          key={index}
          className={clsx(style.item, { [style.selected]: index === selectedIndex }, 'text text_type_d')}
          onClick={() => onThumbClick(index)}
        >
          {item?.year}
        </button>
      ))}
    </nav>
  )
})

TimelineThumbs.displayName = 'TimelineThumbs'
